import { HttpClient, HttpBackend, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { TenantLoginModel } from "../models/tenants/tenant-login.model";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

  private httpClient: HttpClient;  

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }  

  public getTenantLoginConfig(loginAlias: string): Observable<TenantLoginModel> {
    const params = new HttpParams()
      .set('loginalias', loginAlias);  
      
    return this.httpClient.get<TenantLoginModel>(
      Configuration.getApiBaseUrl() + '/login/login-config',
      { params: params }
    );
  }
}